import axios from ".";

export interface Copywriter {
  id: string;
  name: string;
  surname: string;
  email: string;
  status: "Pending" | "Joined";
  role: string;
  disabled: boolean;
  email_confirmed: boolean;
}

export interface InviteCopywriterRequest {
  name: string;
  surname: string;
  email: string;
  organization_id?: string; // Required for admins, optional for clients
}

export interface ResendCopywriterInviteResponse {
  id: string;
  email: string;
  name: string;
  surname: string;
  role: string;
  status: string;
  temporary_password: string;
}

/**
 * Invite a copywriter by creating an account and sending credentials via email
 */
export const inviteCopywriter = async (data: InviteCopywriterRequest) => {
  return axios.post<{ data: Copywriter }>("/client/invite-copywriter", data);
};

/**
 * List all copywriters in the organization
 * @param organizationId - Organization ID (required for admins, optional for clients)
 */
export const listCopywriters = async (organizationId?: string) => {
  const params = organizationId ? { organization_id: organizationId } : {};
  return axios.get<{ data: Copywriter[] }>("/client/copywriters", { params });
};

/**
 * Disable a copywriter by setting their disabled flag to True
 */
export const disableCopywriter = async (copywriterId: string) => {
  return axios.post<{ data: { message: string } }>(
    `/client/copywriters/${copywriterId}/disable`
  );
};

/**
 * Enable a copywriter by setting their disabled flag to False
 */
export const enableCopywriter = async (copywriterId: string) => {
  return axios.post<{ data: { message: string } }>(
    `/client/copywriters/${copywriterId}/enable`
  );
};

/**
 * Resend invitation email to a copywriter with a new temporary password
 */
export const resendCopywriterInvite = async (copywriterId: string) => {
  return axios.post<{ data: ResendCopywriterInviteResponse }>(
    `/client/copywriters/${copywriterId}/resend-invite`
  );
};
